module.exports = __webpack_public_path__ + "static/img/jiantou.ea935cf8.svg";